/**
 * @deprecated USDT/CNY 汇率旧接口不在新 Business API 中。
 * 返回固定占位，避免 404。
 */
export const getUsdtCnyRate = async (): Promise<{ rate: string }> => ({
  rate: '7.2',
});
